import { render, staticRenderFns } from "./CreateSystemUser.vue?vue&type=template&id=2dab70a7&"
import script from "./CreateSystemUser.vue?vue&type=script&lang=js&"
export * from "./CreateSystemUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports